import type { Category } from "../types";

const fetchCategories = async (
	_tenantId: string,
	_appId: string,
): Promise<Category[]> => {
	return [];
};

export { fetchCategories };
